import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Chip from "@material-ui/core/Chip";
import VisibilityIcon from "@material-ui/icons/Visibility";
import TabPanel from "utils/components/TabPanel";
import EyepieceTwoSurvey from "components/EyepieceTwoSurvey";
import EyepieceTwoResult from "components/EyepieceTwoResult";
import EyepieceTwoResource from "components/EyepieceTwoResource";
import a11yProps from "utils/a11yProps";

const useStyles = makeStyles((theme) => ({
  appbar: {
    marginTop: theme.spacing(3),
  },
}));

function Eyepiece2() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Fragment>
      {/* <Chip
        color="primary"
        size="medium"
        variant="outlined"
        label={
          <Typography variant="button" display="block">
            Eyepiece Two
          </Typography>
        }
        icon={<VisibilityIcon />}
      /> */}
      <AppBar
        className={classes.appbar}
        position="static"
        color="transparent"
        elevation={0}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          aria-label="menu tabs"
        >
          <Tab label="Survey" {...a11yProps(0)} />
          <Tab label="Results" {...a11yProps(1)} />
          <Tab label="Resources" {...a11yProps(2)} />
        </Tabs>
      </AppBar>

      <TabPanel value={value} index={0}>
        <EyepieceTwoSurvey />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <EyepieceTwoResult/>
      </TabPanel>
      <TabPanel value={value} index={2}>
      <EyepieceTwoResource/>
      </TabPanel>
    </Fragment>
  );
}

export default Eyepiece2;
